import { ReactKeycloakProvider } from '@react-keycloak/web';
import React from 'react';
import { CssBaseline } from '@mui/material';
import Disclaimer from '../../components/disclaimer/desclaimer';
import WSRODashboardProps from '../../assets/props/wsro-props';
import { KeyCloakClient, KeyCloakProviderConfig } from '../../keycloak/keycloak-client';
import { Navigate } from 'react-router-dom';
import NavBar from '../../components/navbar/navbar';

type Props = {};
type State = {
	isLoading: boolean;
	error: string;
	errorOpen: boolean;
	user: any;
	isSuccess: boolean;
	successMessage: string;
	userAcceptEnabled: boolean;
	isAuthenticated: boolean;
	KeycloakReady: boolean;
	loadDashboardReady: boolean;
};

const enigma = require('enigma.js');
const schema = require('enigma.js/schemas/12.612.0');
const QlikConnection = {
	host: 'analytics.cremedatafoundry.com',
	port: '',
	prefix: '',
	isSecure: true,
	// appId: '42a60ac7-e50a-42a9-8313-a2bc319886ba',
	appId: 'efd73c80-b9e7-45a0-bb7f-5f16e15106b9', // new app id
};

export default class SignInSSO extends React.Component<Props, State> {
	userIsLogin;


	constructor(props: Props) {
		super(props);
		this.state = {
			isLoading: true,
			isAuthenticated: false,
			user: {},
			isSuccess: false,
			successMessage: '',
			userAcceptEnabled: false,
			error: '',
			errorOpen: false,
			KeycloakReady: false,
			loadDashboardReady: false,
		};

		this.userIsLogin = localStorage.getItem('userIsLogin') ? localStorage.getItem('userIsLogin') : 'false';
	}

	initialQlikSenseConnection = async () => {
		const session = enigma.create({ schema, url: `wss://${QlikConnection.host}/app/${QlikConnection.appId}` });
		session.on('traffic:sent', (data: any) => console.log('sent:', data));
		session.on('traffic:received', (data: any) => console.log('received:', data));
		const global = await session.open();
		const app = await global.openDoc(QlikConnection.appId);
		const allInfo = await app.getAllInfos();
		// console.log({ allInfo });
		// console.log({ app });
		// const sheet = await app.getObject('5e639a90-c2e8-46ad-81a9-3a22964ee7f6');
		const sheet = await app.getObject('43f497ab-3285-46db-a87e-778fa60a4978'); // new sheet id
		const appLayout = await app.getAppLayout();
		// console.log({ appLayout });
		// render app thumnail in div with id 'app-section'
		const appSection = document.getElementById('wsro-dashboard');
		// console.log(appLayout.qThumbnail);
		const thumnailUrl = `https://dashboard-dev.cremedatafoundry.com${appLayout.qThumbnail.qUrl}`;
		// console.log(thumnailUrl);
		// appSection.innerHTML = `<img src="${thumnailUrl}" alt="app-thumbnail" />`;
	}


	getUserEnablementStatus = async (token: any) => {
		const getUserEnablementStatus = {
			url: 'https://wsro.cremedatafoundry.com/enablement',
			// url: 'https://wsro-dev.cremedatafoundry.com/enablement',
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				"Authorization": `Bearer ${token}`,
				'Accept': 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
				'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
				'Access-Control-Allow-Credentials': 'true',
			},
		}

		fetch(getUserEnablementStatus.url, getUserEnablementStatus)
			.then(response => response.json())
			.then(data => {
				// set state to true if user is enabled
				if (data.enabled) {
						this.setState({ userAcceptEnabled: true, loadDashboardReady: true });
					// set local storage to true
				} else {
					this.setState({ userAcceptEnabled: false, loadDashboardReady: true });
					localStorage.setItem('userEnablement', 'false');
				}
			})
			.catch(error => console.log(error));
	};


	onKeyCloakEvent = (event: any, error: any) => {
		if (event === 'onAuthSuccess') {
		} else if (event === 'onAuthError') {
			console.log('onAuthError', error, error.message);
			debugger;
		} else if (event === 'onAuthLogout') {
		}

		if (event && event === 'onReady') {
			this.setState({ KeycloakReady: true });
		}

	}

	onKeyCloakTokens = (tokens: any) => {
		const { accessToken, idToken, token } = tokens;
		localStorage.setItem('accessToken', token);
		this.getUserEnablementStatus(token);
	}

	disclaimerStatusCallback = (status: boolean) => {
		this.setState({ userAcceptEnabled: status });
	}


	render() {
		return (
			<div>
				<div>
					<ReactKeycloakProvider
						authClient={KeyCloakClient}
						initOptions={{ onLoad: "login-required"}}
						onEvent={this.onKeyCloakEvent}
						onTokens={this.onKeyCloakTokens}
					>
						{this.state.KeycloakReady ?

							<>
								<CssBaseline />
								<NavBar props={WSRODashboardProps.navbar} />
								{this.state.userAcceptEnabled ? (
									<div>
										<iframe id="qlikIFrame" src="https://analytics.cremedatafoundry.com/single/?appid=42a60ac7-e50a-42a9-8313-a2bc319886ba&sheet=69fb56ac-f6c5-4ac2-9c98-23930bad0fe9&select=clearall" style={{ border: 'none', width: '100%', height: '91vh' }}></iframe>
									</div>
								) : (
									<div>
										{this.state.loadDashboardReady ?
											<Disclaimer
												data={WSRODashboardProps.disclaimerProps}
												onClick={(status) => this.disclaimerStatusCallback(status)}
												showDisclaimer={!this.state.userAcceptEnabled}
											/>
											: <></>}
									</div>
								)}
							</>
							: <></>}
					</ReactKeycloakProvider>
				</div>
			</div>
		);
	}
}
